export const LogoutIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5 2.32127C10.1573 2.27431 9.80663 2.25 9.45 2.25C5.47355 2.25 2.25 5.27208 2.25 9C2.25 12.728 5.47355 15.75 9.45 15.75C9.80663 15.75 10.1573 15.7257 10.5 15.6788"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.875 7.125L15.75 9L13.875 10.875M8.25 9H15.2934"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
